// Brand EKG divider — echoes the heartbeat line in the CPR logo.
// Keeps the visual identity consistent across pages without re-using the full logo.
export default function EkgLine({ className = "", height = 40, label }) {
    return (
        <div className={className} data-testid={label || "ekg-line"}>
            <svg
                className="ekg-divider"
                viewBox="0 0 600 40"
                preserveAspectRatio="none"
                style={{ height }}
                aria-hidden="true"
            >
                <path
                    d="M0 20 L 180 20 L 200 20 L 215 20 L 230 4 L 245 36 L 260 2 L 275 38 L 290 20 L 600 20"
                    stroke="currentColor"
                    strokeWidth="2.5"
                />
            </svg>
        </div>
    );
}
